import { render, staticRenderFns } from "./Admin_dashboard_sh.vue?vue&type=template&id=9020dbde&"
import script from "./Admin_dashboard_sh.vue?vue&type=script&lang=js&"
export * from "./Admin_dashboard_sh.vue?vue&type=script&lang=js&"
import style0 from "./Admin_dashboard_sh.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports